// extracted by mini-css-extract-plugin
module.exports = {"Pill":"Fab_Pill__7q51V","Container":"Fab_Container__sIutg"};